import * as React from 'react'

import MuiAccordion, { type AccordionProps } from '@mui/material/Accordion'
import styled from '@mui/material/styles/styled'

export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion elevation={0} disableGutters {...props} />
))(({ theme }) => ({
  marginTop: theme.spacing(2),
  '&:before': {
    display: 'none',
  },
}))
